export default __webpack_public_path__ + "static/media/usa-star-3x.c63998ca.png";